import React             from 'react';
import PropTypes         from 'prop-types';

/* *********************************************************************************** */
/* **********                                                               ********** */
/* **********                              Bandeau                          ********** */
/* **********                                                               ********** */
/* *********************************************************************************** */

export class Bandeau extends React.Component {

        /* ---------------------- */
        /* Affichage du composant */
        /* ---------------------- */

        render () {

            /* ------------------------------ */
            /* Définition des CSS d'affichage */
            /* ------------------------------ */
        
            const styleBandeau = {
                width           : this.props.largeur ? this.props.largeur : "1063px",
                height          : "100px",
                backgroundColor : "#723937",
                display         : "block",
                marginLeft      : "auto",
                marginRight     : "auto",
                marginBottom    : "10px",
                textAlign       : 'center'      
            };

            /* ------------------- */
            /* Renvoi du composant */
            /* ------------------- */

            return (

                <div style={styleBandeau} >

                  <div className="gesteAros"> </div>

                </div>

            )

        }
  
} // Fin de la classe Bandeau

/* ------------------------------------ */
/* Définition de la structure des props */
/* ------------------------------------ */

Bandeau.defaultProps = {
    largeur : null
}

Bandeau.propTypes = {
  largeur : PropTypes.string
}


// WEBPACK FOOTER //
// ./src/components/commun/Bandeau.js